import React from 'react';
import { Link } from 'react-router-dom';
import '../../stylesheets/home/sharedSectionStyles.css';

const ResourcesSupportSection = () => {
  return (
    // Lo convertimos en una simple tarjeta, igual que las otras
    <div className="content-card">
      <h2>Mentor IA 24/7</h2>
      <p className="section-subtitle">
      Recibe orientación personalizada en cualquier momento. El Mentor IA analiza tu perfil y te brinda recomendaciones para avanzar según tu objetivo.
      </p>
      <ul className="feature-list">
        <li>Recomendaciones según tu ruta.</li>
        <li>Acompañamiento continuo.</li>
        <li>Orientación personalizada.</li>
      </ul>
      <Link to="/plans/" className="cta-button main-blue">
        Accede a los recursos
      </Link>
    </div>
  );
};

export default ResourcesSupportSection;